/** Dashboard Stock: count on every plan; reports and variance email stay Pro. */

export const isProStockTakePlan = plan =>
  String(plan || '')
    .trim()
    .toLowerCase() === 'pro'

export const canOpenDashboardStockTakes = () => true

export const canUseStockTakeReports = plan => isProStockTakePlan(plan)

export const canUseStockTakeVarianceEmail = plan => isProStockTakePlan(plan)
